module.exports = __webpack_public_path__ + "assets/img/message-empty.8d069950.png";